<template>
  <router-link
    :to="handleRouterTo()" >
    号码预测
  </router-link>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    handleRouterTo () {
      return {
        name: 'LotteryChartDetail',
        query: {
          id: this.id,
          chart: 'numAnalysis'
        }
      }
    }
  }
}
</script>
